import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { SemanticICONS } from 'semantic-ui-react'
import styled from 'styled-components'
import StockExChangeService from '~/api/services/stockExchange'
import CustomIcon from '~/components/CustomIcon'
import Drawer from '~/components/Drawer'
import { formatNumber, handleErrors } from '~/utils/helpers'

interface Props {
  contractId: any
  handleHiddenDrawer: () => void
}

export const ContractList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.1rem;
  padding: 0.6rem 0.2rem;
  font-size: 15px !important;

  .row {
    display: flex;
    align-items: flex-start;
    font-size: 15px !important;
    padding: 7px;
    gap: 0.8rem;
  }

  .label {
    display: flex;
    font-size: 15px !important;
    align-items: baseline;
  }

  .value {
    font-size: 15px !important;
    font-weight: bold;
    margin-left: 2px;
    word-break: break-all;
  }
`;

const ShowStoneXBle:React.FC<Props> = (props) => {
  const { t } = useTranslation()
  const { contractId, handleHiddenDrawer } = props

  const [isLoading, setIsLoading] = useState(false)
  const [contractData, setContractData] = useState(null)

  const detailFields = [
    {
      name: t('Supplier No.'),
      key: 'supplierNo',
      icon: 'address card'
    },
    {
      name: t('Company name'),
      key: 'companyName',
      icon: 'user outline'
    },
    {
      name: 'Absicherungsmenge (in kg)',
      key: 'confirmedAmount',
      icon: 'archive',
      decimalScale: 0
    },
    {
      name: 'Kontraktpreis (in €/kg)',
      key: 'contractPrice',
      icon: 'euro sign',
      decimalScale: 4
    },
    {
      name: 'Kontraktvolumen (in €)',
      key: 'contractVolume',
      icon: 'money bill alternate outline',
      decimalScale: 2
    },
    {
      name: 'Settlement Kurs (in €/kg)',
      key: 'settlementPrice',
      icon: 'balance scale',
      decimalScale: 4
    },
    {
      name: 'Settlement Volumen (in €)',
      key: 'settlementVolume',
      icon: 'calculator',
      decimalScale: 2
    },
    {
      name: 'Cash Amount (in €)',
      key: 'cashAmount',
      icon: 'money bill',
      decimalScale: 2
    },
    {
      name: 'Gebühren (in €)',
      key: 'fees',
      icon: 'euro sign',
      decimalScale: 2
    }
  ];

  useEffect(() => {
    if(contractId) {
      fetchDetails()
    }
  }, [contractId])

  async function fetchDetails() {
    setIsLoading(true)
    try {
      const response = await StockExChangeService.getStoneXContractDetails(contractId)
      setContractData(response.data[0])
    } catch(error) {
      handleErrors(error)
    }
    setIsLoading(false)
  }

  function renderContent() {
    return <ContractList>
      {detailFields.map(field => {
        const { key, name, icon } = field
        return <div className='row' key={key}>
          <div className='label'>
            <CustomIcon name={icon as SemanticICONS} />
            {name}:
          </div>
          <div className='value'>
            {!isNaN(field?.decimalScale) ? formatNumber(contractData?.[key] || 0, field.decimalScale) || '' : contractData?.[key] || ''}
          </div>
        </div>
      })}
    </ContractList>
  }

  return <Drawer
    isBusy={isLoading}
    isVisible={Boolean(contractId)}
    content={renderContent()}
    header={'Details'}
    onHide={() => {
      setContractData(null)
      handleHiddenDrawer();
    }}
    closeOnEscape
  />
}
export default ShowStoneXBle